import React from 'react';
import { Button, FormControlLabel, Switch, Typography } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import styles from './NbaPage.module.css';

type NbaToolbarProps = {
  enabled: boolean;
  selectedCount: number;
  duplicateInProgress: boolean;
  onToggleEnabled: (next: boolean) => void;
  onClear: () => void;
  onDuplicate: () => void;
};

export const NbaToolbar: React.FC<NbaToolbarProps> = ({
  enabled,
  selectedCount,
  duplicateInProgress,
  onToggleEnabled,
  onClear,
  onDuplicate,
}) => (
  <div className={styles.bulkBar}>
    <div className={styles.bulkBarLeft}>
      <FormControlLabel
        control={(
          <Switch
            checked={enabled}
            color="primary"
            onChange={(e) => onToggleEnabled(e.target.checked)}
          />
        )}
        label="Bulk duplicate"
      />
      {enabled && (
        <Typography
          className={styles.bulkBarCount}
          color="textSecondary"
          variant="body2"
        >
          Selected:
          {' '}
          {selectedCount}
        </Typography>
      )}
    </div>
    {enabled && (
      <div className={styles.bulkBarActions}>
        <Button
          disabled={selectedCount === 0 || duplicateInProgress}
          size="small"
          onClick={onClear}
        >
          Clear
        </Button>
        <Button
          color="primary"
          disabled={selectedCount === 0 || duplicateInProgress}
          size="small"
          startIcon={<FileCopyIcon />}
          variant="contained"
          onClick={onDuplicate}
        >
          Duplicate
          {selectedCount ? ` (${selectedCount})` : ''}
        </Button>
      </div>
    )}
  </div>
);


